// extracted by mini-css-extract-plugin
module.exports = {"buttonSmSecondaryDanger":"ButtonSmSecondaryDanger_buttonSmSecondaryDanger__2HS9j"};